export default __webpack_public_path__ + "static/media/bg-saint-malo-min.72b9870f.jpg";